<div class="col-2" *ngIf="showSidebar">
  <app-admin-side-bar [menuType]="menuType"></app-admin-side-bar>
</div>
<div [ngClass]="showSidebar ? 'col-10' : fullWidthClass">
  <ng-content></ng-content>
</div>
